export const shouldRenderNesting = (
	condition?: boolean | null,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	stack: string[],
	nestingId: string,
) => condition === true || Boolean(stack && stack.includes(nestingId));
